<template>
  <header class="system-communications-email-header">
    <div class="system-communications-email-header-action-wrapper">
      <button class="btn btn-primary btn-extra-round" @click="onClick">
        {{ buttonTitle }}
      </button>
    </div>
  </header>
</template>

<script>
import EventBus from "@packages/event-bus";

export default {
  props: {},

  components: {},

  computed: {
    isContentSaving() {
      return this.$store.state.marketing.email.isContentSaving;
    },
    emailId() {
      return this.$store.state.marketing.email.edit.emailId
        ? this.$store.state.marketing.email.edit.emailId
        : this.itemInSessionStorage.id;
    },
    buttonTitle() {
      return this.isEmailEditable
        ? this.$t("message.generics.message.save")
        : this.$t("message.generics.message.edit");
    },
  },

  data() {
    return {
      isEmailEditable: false,
    };
  },

  methods: {
    emitSaveContent() {
      EventBus.$emit("SAVE_CONTENT");
    },
    emitEditContent() {
      this.isEmailEditable = true;
      EventBus.$emit("EDIT_CONTENT");
    },
    onClick() {
      if (this.isEmailEditable) {
        this.emitSaveContent();
      } else {
        this.emitEditContent();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.system-communications-email-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .system-communications-email-header-action-wrapper {
    display: flex;
    align-items: center;
  }
}
</style>
